<!-- <ion-header [hidden]="inAppNav" class="order-header"> -->
<ion-header class="order-header">
    <ion-toolbar>
        <ion-buttons slot="start">
            <custom-back-button (backButtonClick)="backButtonClick()"
                [forceHideText]="orderManager?.mode === 'delivery'"></custom-back-button>
            <!-- delivery -->
            <ion-button (click)="popUpAddressModal({});$event.stopPropagation;" class="back-btn AQA-back-btn"
                *ngIf="this.orderManager.mode==='delivery' && this.memberService.member">
                <ion-icon name="home" *ngIf="this.addressManagerService.isPickup"></ion-icon>
                <img *ngIf="!this.addressManagerService.isPickup" src="assets/images/deli-motor.svg">

                <p class="address-selected">
                    <span
                        *ngIf="this.addressManagerService.isPickup">{{this.addressManagerService.pickupAddress?.name}}</span>
                    <span
                        *ngIf="!this.addressManagerService.isPickup">{{this.addressManagerService.currentAddress?.name}}</span>
                </p>
                <ion-icon name="ios-arrow-down" class="icon-address-more"></ion-icon>
            </ion-button>

        </ion-buttons>
        <ion-title *ngIf="store && this.orderService.isCourt">
            <ion-select okText="Okay!" (ionChange)="goStore()" [(ngModel)]="selectedValue" interface="popover"
                placeholder="{{store?.name}}">
                <template *ngFor="let store of stores">
                    <ion-select-option value="{{store.id}}">
                        {{store.name}}
                    </ion-select-option>
                </template>
            </ion-select>
        </ion-title>

        <!-- basket -->
        <ion-buttons slot="primary">
            <div *ngIf="settings.enableSearch">
                <ion-button fill="clear" (click)="tapSearch()" class="search-btn">
                    <ion-icon name="md-search" class="h-nav-cart"></ion-icon>
                </ion-button>
            </div>

            <!-- sevice-btn flow -->
            <div class="service-select-box" *ngIf="false">
                <ion-button fill="clear" slot="primary" class="btn-service" (click)="popUpService($event)">
                    <div class="img-box service">
                        <img src="../assets/images/icon_waiter.gif" />
                    </div>
                </ion-button>
            </div>

            <div class="h-nav">
                <ion-button fill="clear" (click)="cartClicked()">
                    <ion-icon name="md-cart" class="h-nav-cart">
                        <!-- <span *ngIf="!multOrderManager.enableMutlOrder && orderManager.getOrder().orderitems.length > 0" class="news"></span>
                                <span *ngIf="multOrderManager.enableMutlOrder && multOrderManager.getOrderCount() > 0" class="news"></span> -->
                    </ion-icon>
                    <ion-badge *ngIf="!multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{orderManager.count}}</ion-badge>
                    <ion-badge *ngIf="multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{multOrderManager.getOrderCount()}}</ion-badge>
                </ion-button>
            </div>
        </ion-buttons>
    </ion-toolbar>

    <!-- <ion-toolbar>

            <ion-title *ngIf="store">{{store.brand.name}}<span *ngIf="orderService.spot"> ({{orderService.spot}})</span></ion-title>

            <ion-buttons end>
                <button (click)="cartClicked()" ion-button fill="clear" slot="start" color="contrast" class="order_sum_button md-font-size">
                       <ion-icon class="order_sum_icon" name='cart' color="contrast">
                       </ion-icon>
                </button>
            </ion-buttons>
        </ion-toolbar> -->
</ion-header>

<ion-content *ngIf="categories?.length > 0" class="basePage">

    <!-- aiRecommend -->
    <div class="content-box" *ngIf="hasRecommendation">
        <ng-container *ngIf="hasRecommendation">
            <div class="scrollX-wrapper">
                <p class="page-title">{{"pages.base-category-page.recommendation" | translate}}</p>
                <div class="category-group-wrapper">
                    <ng-container *ngFor="let recomGroup of recommendationGroups">
                        <ng-container *ngIf="recomGroup.recommendations && recomGroup.recommendations.length > 1">
                            <ion-card class="item-list-box item-box card-shadow twoNhalf-card" no-lines
                                (click)="recommendationGroupclicked(recomGroup)">

                                <div item-end class="right-wrapper">
                                    <!-- <ion-avatar *ngIf="recomGroup.recommendations[0].item?.getImage('default',360,true)">
                                        <img *ngIf="recomGroup.recommendations[0].item?.getImage('default',360,true)"
                                            src="{{recomGroup.recommendations[0].item?.getImage('default',360,true)}}">
                                    </ion-avatar> -->
                                    <div *ngIf="recommedImage(recomGroup)" class="img-box"
                                        [ngStyle]="{'background-image': 'url(' + recommedImage(recomGroup) + ')'}">
                                    </div>

                                    <!-- <ion-avatar
                                        *ngIf="!recomGroup.recommendations[0].item?.getImage('default',360,true)">
                                        <img src="{{defaultItemImage}}">
                                    </ion-avatar> -->
                                    <div *ngIf="!recomGroup.recommendations[0].item?.getImage('default',360,true)"
                                        class="img-box"
                                        [ngStyle]="{'background-image': 'url(' + defaultItemImage + ')'}">
                                    </div>
                                </div>

                                <div class="info-box">
                                    <p class="name-text line-clamp">{{ recomGroup.name }}</p>

                                    <div class="sub-info-box">

                                        <div class="price-box">
                                            <p class="price-text itemPrice-text">
                                                {{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                                                {{recomGroup.recommendations[0].item|itemPrice}}
                                                {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </ion-card>
                        </ng-container>

                        <ng-container *ngIf="recomGroup.recommendations && recomGroup.recommendations.length == 1">
                            <ng-container *ngFor="let recom of recomGroup.recommendations">
                                <ng-container
                                    *ngIf="!(inventoryManager.isHidden(recom.item) || inventoryManager.isSoldout(recom.item))">
                                    <ion-card class="item-list-box item-box card-shadow twoNhalf-card" no-lines
                                        (click)="recomItemclicked(recom.item, recom)">
                                        <div item-end class="right-wrapper">
                                            <!-- <ion-avatar *ngIf="recom.item?.getImage('default',360,true)">
                                                <img *ngIf="recom.item?.getImage('default',360,true)"
                                                    src="{{recom.item?.getImage('default',360,true)}}">
                                            </ion-avatar> -->
                                            <!-- <ion-avatar *ngIf="!recom.item?.getImage('default',360,true)">
                                                <img src="{{defaultItemImage}}">
                                            </ion-avatar> -->


                                            <div *ngIf="recom.item?.getImage('default',360,true)" class="img-box"
                                                [ngStyle]="{'background-image': 'url(' + recom.item?.getImage('default',360,true) + ')'}">
                                                <div class="btn-box" *ngIf="!isSet(recom) && !recom.item?.variations">
                                                    <ng-container *ngIf="orderManager.getQuantity(recom?.item) > 0">
                                                        <ion-button class="remove-btn"
                                                            (click)="removeClicked(recom.item);$event.stopPropagation();">
                                                            <ion-icon name="remove"></ion-icon>
                                                        </ion-button>
                                                        <span
                                                            class="qty-text">{{orderManager.getQuantity(recom?.item)}}</span>
                                                    </ng-container>

                                                    <ion-button class="add-btn" fill="clear">
                                                        <ion-icon name="add"></ion-icon>
                                                    </ion-button>
                                                </div>
                                            </div>

                                            <div *ngIf="!recom.item?.getImage('default',360,true)" class="img-box"
                                                [ngStyle]="{'background-image': 'url(' + defaultItemImage + ')'}">
                                                <div class="btn-box" *ngIf="!isSet(recom) && !recom.item?.variations">
                                                    <ng-container *ngIf="orderManager.getQuantity(recom?.item) > 0">
                                                        <ion-button class="remove-btn"
                                                            (click)="removeClicked(recom.item);$event.stopPropagation();">
                                                            <ion-icon name="remove"></ion-icon>
                                                        </ion-button>
                                                        <span
                                                            class="qty-text">{{orderManager.getQuantity(recom?.item)}}</span>
                                                    </ng-container>

                                                    <ion-button class="add-btn">
                                                        <ion-icon class="add-btn" name="add"></ion-icon>
                                                    </ion-button>
                                                </div>

                                            </div>


                                        </div>
                                        <!-- <div class="sub-info-box">
    
                                            
                                        </div> -->
                                        <div class="info-box">
                                            <p class="name-text line-clamp">{{ recom.item.name }}</p>
                                            <div class="price-box">
                                                <p class="price-text itemPrice-text">
                                                    {{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                                                    {{recom?.item|itemPrice}}
                                                    {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
                                                </p>
                                            </div>
                                        </div>
                                    </ion-card>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </ng-container>

                </div>
            </div>
        </ng-container>
    </div>


    <ion-grid class="div-grid">
        <!-- need a flag -->
        <ion-row *ngIf="mode == 'list'" class="main-cat listMode">

            <!-- 1-1 -->
            <ion-col *ngFor="let category of categories;let i = index" col-12 class="full-col" size="12">
                <ion-card tappable (click)="itemClicked(category,i)" class="col-card">
                    <div class="cate-img img-box" [ngStyle]="{'height.px': cateBoxHeight}">
                        <img src="{{imgs[i]}}" (error)="showEmpty(i)" />
                    </div>
                    <div class="card-title sm-font-size">
                        <p>{{category.name}}</p>
                    </div>
                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="mode == 'grid'" class="main-cat grid2">
            <!-- 1-2 -->
            <ion-col *ngFor="let category of categories;let i = index" class="half-col" size="6">
                <ion-card tappable (click)="itemClicked(category,i)" class="col-card">
                    <div class="cate-img img-box" [ngStyle]="{'height.px': cateBoxHeight}">
                        <img src="{{imgs[i]}}" (error)="showEmpty(i)">

                        <!-- <div class="title-bg"> -->
                        <!-- <img src="../../../assets/images/corner-shadow.png" alt=""> -->
                        <!-- <div class="trans-bg"></div> -->
                        <!-- </div> -->
                    </div>
                    <div class="div-title">
                        <!-- <span></span> -->
                        <p class="text-title">{{category.name}}</p>
                        <!-- <span></span> -->
                    </div>

                </ion-card>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="mode == 'grid3'" class="main-cat grid3">
            <!-- 1-3 -->
            <ion-col *ngFor="let category of categories;let i = index" class="one-third-col" size="4">
                <ion-card tappable (click)="itemClicked(category,i)" class="col-card">
                    <div class="cate-img img-box" [ngStyle]="{'height.px': cateBoxHeight}">
                        <img src="{{imgs[i]}}" (error)="showEmpty(i)" />
                    </div>
                    <div class="card-title sm-font-size">
                        <p>{{category.name}}</p>
                    </div>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>

    <!-- <ion-list *ngIf="listMode">
            <button ion-item tappable (click)="itemClicked(category)" *ngFor="let category of categories" class="item-cat-list">
                <div class="card-title p-space-02 icon-{{category.id}}">
                    {{category.name}}
                </div>
            </button>
        </ion-list> -->


</ion-content>

<ion-content *ngIf="categories?.length == 0">
    <div class="emptyPage">

        {{"global.no-menu" | translate}}

    </div>
</ion-content>


<!-- <ion-footer>

        <ion-toolbar class="theme1" no-padding>

            <button ion-button expand="block" size="large" (click)="cartClicked()" class="btn-order-panel">
                <ion-grid class="panel-counter">
                    <ion-row>

                        <ion-col col-12 no-padding>
                            <div class="footer-panel-counter">
                                <ion-badge [ngClass]="{'animated shake' : isBounce}" class="badge-item">{{orderManager.count}}<span>{{"global.no-of-items" | translate}}</span></ion-badge>

                                <span>{{"global.checkout" | translate}} ${{orderManager.order.grandTotal}}</span>

                            </div>
                        </ion-col>


                    </ion-row>

                </ion-grid>
                <ion-icon slot="start" name="ios-arrow-forward"></ion-icon>
            </button>

        </ion-toolbar>

<ion-footer> -->